import { render } from "./UplodeView.vue?vue&type=template&id=65d26cd8"
import script from "./UplodeView.vue?vue&type=script&lang=js"
export * from "./UplodeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__